export interface PackageData {
  id: number;
  candidate_id: number;
  status: string;
  resume_status: string;
  skm_status: string;
  submissions_status: string;
  approved_at: string | null;
  approved_by: string | null;
  completed_at: string | null;
  memo_text: string;
  memo_generated: boolean;
  memo_generated_at: string | null;
  background_notes: string;
  target_firm: string;
  target_role: string;
  resume_original_url: string | null;
  resume_optimized_url: string | null;
  resume_original_filename: string | null;
  resume_optimized_filename: string | null;
  ready_to_submit: boolean;
  all_sections_complete: boolean;
  last_resume_sent_at: string | null;
  updated_at: string;
}

export interface Candidate {
  id: number;
  full_name: string;
  firm_name: string;
  practice_area: string;
  pipeline_stage: string;
  dnc_status: string;
  jd_year: number | null;
  law_school: string;
  candidate_type: string;
  location: string;
  specialties: string;
}

export interface SubmissionRow {
  package_submission_id: number;
  submission_id: number;
  firm_name: string;
  job_id: number | null;
  job_title: string | null;
  submission_method: string;
  status: string;
  notes: string;
  created_at: string;
}

export interface SkmContact {
  id: number;
  skm_contact_id: number;
  contact_name: string;
  firm_name: string;
  status: string;
  responded_at: string | null;
}

export interface SkmBlast {
  id: number;
  status: string;
  contact_count: number;
  sent_at: string | null;
  contacts: SkmContact[];
}

export interface ExcludedFirm {
  firm_name: string;
  contact_name: string;
  reason: string;
}

export function csrfToken(): string {
  return (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content ?? "";
}

export function fmt(iso: string | null) {
  return iso ? new Date(iso).toLocaleDateString() : "—";
}
